import { render, staticRenderFns } from "./WeekMenu.vue?vue&type=template&id=da7980cc&scoped=true&"
import script from "./WeekMenu.vue?vue&type=script&lang=js&"
export * from "./WeekMenu.vue?vue&type=script&lang=js&"
import style0 from "./WeekMenu.vue?vue&type=style&index=0&id=da7980cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da7980cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
installComponents(component, {VBtn,VBtnToggle})
